import {Dialog, DialogProps} from './components/dialog'
import {createOverlay} from '@chakra-ui/react'

export const dialog = createOverlay<DialogProps>(props => {
  return <Dialog closeOnInteractOutside={false} {...props} />
})
